import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.dp.monitoring"))),
      ]),
      _c(VCard, { staticClass: "mt-2 pa-2" }, [
        _c(
          "h5",
          [
            _vm._v("Appengine"),
            _c(
              VRow,
              _vm._l(_vm.srcEmbebed.appengine, function (graph) {
                return _c(
                  VCol,
                  { key: graph.id, attrs: { sm: "12", lg: "6" } },
                  [
                    _c("a", { attrs: { href: graph, target: "_blank" } }, [
                      _vm._v(_vm._s(_vm.$t("frases.new_tab"))),
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("open_in_new"),
                      ]),
                    ]),
                    _c("b-embed", {
                      staticClass: "cont-frame",
                      attrs: {
                        type: "iframe",
                        src: graph,
                        allowfullscreen: "",
                      },
                    }),
                  ],
                  1
                )
              }),
              1
            ),
            _c("hr"),
            _c("h5", [_vm._v("FireStore")]),
            _c(
              VRow,
              _vm._l(_vm.srcEmbebed.firestore, function (graph) {
                return _c(
                  VCol,
                  { key: graph.id, attrs: { sm: "12", lg: "6" } },
                  [
                    _c("a", { attrs: { href: graph, target: "_blank" } }, [
                      _vm._v(_vm._s(_vm.$t("frases.new_tab"))),
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("open_in_new"),
                      ]),
                    ]),
                    _c("b-embed", {
                      staticClass: "cont-frame",
                      attrs: {
                        type: "iframe",
                        src: graph,
                        allowfullscreen: "",
                      },
                    }),
                  ],
                  1
                )
              }),
              1
            ),
            _c("hr"),
            _c("h5", [_vm._v("BigQuery")]),
            _c(
              VRow,
              _vm._l(_vm.srcEmbebed.bigquery, function (graph) {
                return _c(
                  VCol,
                  { key: graph.id, attrs: { sm: "12", lg: "6" } },
                  [
                    _c("a", { attrs: { href: graph, target: "_blank" } }, [
                      _vm._v(_vm._s(_vm.$t("frases.new_tab"))),
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("open_in_new"),
                      ]),
                    ]),
                    _c("b-embed", {
                      staticClass: "cont-frame",
                      attrs: {
                        type: "iframe",
                        src: graph,
                        allowfullscreen: "",
                      },
                    }),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }